import React from 'react'

import PropTypes from 'prop-types'

import './emotion-selector.css'

const EmotionSelector = (props) => {
  return (
    <div className="emotion-selector-container">
      <span className="emotion-selector-text">{props.Text}</span>
      <span>{props.emotion}</span>
      <div className='emotion-selector-container1'>
        <img
          alt={props.image_alt}
          src={props.image_src}
          className={`emotion-selector-image ${props.emotion == 'Anger' && 'emotion-selected'}`}
          onClick={()=>props.setEmotion('Anger')}
        />
        <img
          alt={props.image_alt1}
          src={props.image_src1}
          className={`emotion-selector-image1 ${props.emotion == 'Disgust' && 'emotion-selected'}`}
          onClick={()=>props.setEmotion('Disgust')}
        />
        <img
          alt={props.image_alt2}
          src={props.image_src2}
          className={`emotion-selector-image2 ${props.emotion == 'Fear' && 'emotion-selected'}`}
          onClick={()=>props.setEmotion('Fear')}
        />
        <img
          alt={props.image_alt3}
          src={props.image_src3}
          className={`emotion-selector-image3 ${props.emotion == 'Happiness' && 'emotion-selected'}`}
          onClick={()=>props.setEmotion('Happiness')}
        />
      </div>
      <div className="emotion-selector-container2">
        <img
          alt={props.image_alt4}
          src={props.image_src4}
          className={`emotion-selector-image4 ${props.emotion == 'Neutral' && 'emotion-selected'}`}
          onClick={()=>props.setEmotion('Neutral')}
        />
        <img
          alt={props.image_alt5}
          src={props.image_src5}
          className={`emotion-selector-image5 ${props.emotion == 'Sadness' && 'emotion-selected'}`}
          onClick={()=>props.setEmotion('Sadness')}
        />
        <img
          alt={props.image_alt6}
          src={props.image_src6}
          className={`emotion-selector-image6 ${props.emotion == 'Surprise' && 'emotion-selected'}`}
          onClick={()=>props.setEmotion('Surprise')}
        />
      </div>
    </div>
  )
}

EmotionSelector.defaultProps = {
  image_src: '/playground_assets/angry-200h.png',
  image_src2: '/playground_assets/scare%20%5B1%5D-200h.png',
  emotion: 'Sadness',
  image_alt5: 'image',
  image_alt: 'image',
  image_alt3: 'image',
  image_src1: '/playground_assets/sick1-200h.png',
  image_src5:
    '/playground_assets/white%20simple%20letter%20m%20logo%20%5B1%5D1-200h.png',
  Text: 'We just detected that you are feeling:',
  image_src3: '/playground_assets/smiley1-200h.png',
  image_alt4: 'image',
  image_alt1: 'image',
  image_src4: '/playground_assets/confusing1-200h.png',
  image_alt2: 'image',
  image_src6: '/playground_assets/surprised1-200h.png',
  image_alt6: 'image',
}

EmotionSelector.propTypes = {
  image_src: PropTypes.string,
  image_src2: PropTypes.string,
  emotion: PropTypes.string,
  image_alt5: PropTypes.string,
  image_alt: PropTypes.string,
  image_alt3: PropTypes.string,
  image_src1: PropTypes.string,
  image_src5: PropTypes.string,
  Text: PropTypes.string,
  image_src3: PropTypes.string,
  image_alt4: PropTypes.string,
  image_alt1: PropTypes.string,
  image_src4: PropTypes.string,
  image_alt2: PropTypes.string,
  image_src6: PropTypes.string,
  image_alt6: PropTypes.string,
}

export default EmotionSelector
